import absencesBalancesHandlers from './absences/balances';
import absencesEditHandlers from './absences/edit';
import absencesLoadingHandlers from './absences/loading';
import absencesNotificationsHandlers from './absences/notifications';
import absencesRequestsHandlers from './absences/requests';
import absencesTimesheetsHandlers from './absences/timesheets';
import clientsHandlers from './clients';
import dealActivitiesHandlers from './deals/activities';
import dealConversionHandlers from './deals/conversion';
import dealFormHandlers from './deals/dealForm';
import dealNamesHandlers from './deals/dealNames';
import dealOpenHandlers from './deals/dealOpen';
import dealsLoadingHandlers from './deals/dealsLoading';
import phaseClosureHandlers from './deals/phaseClosure';
import dealPipelineHandlers from './deals/pipeline';
import tenderToDealHandlers from './deals/tenderToDeal';
import dealViewsHandlers from './deals/views';
import jiraAuthorsHandlers from './jira/authors';
import jiraConsumptionHandlers from './jira/consumption';
import jiraEpicMonthsHandlers from './jira/epicMonths';
import jiraEpicsHandlers from './jira/epics';
import jiraIssueKeyMapHandlers from './jira/issueKeyMap';
import jiraLabelHoursHandlers from './jira/labelHours';
import jiraLogsHandlers from './jira/logs';
import jiraSyncHandlers from './jira/sync';
import jiraUnmatchedHandlers from './jira/unmatchedWorklogs';
import planningAssignmentsHandlers from './planning/assignments';
import planningDeleteDayHandlers from './planning/deleteDay';
import phaseInfoHandlers from './planning/phaseInfo';
import planningValidationHandlers from './planning/validation';
import projectArchiveHandlers from './projects/archive';
import maintenanceCarryOverHandlers from './projects/maintenanceCarryOver';
import phaseEndAlertsHandlers from './projects/phaseEndAlerts';
import phaseSaveHandlers from './projects/phaseSave';
import seenAlertsHandlers from './projects/seenAlerts';
import tenderAnalysisHandlers from './tenders/analysis';
import tenderDeleteDocumentHandlers from './tenders/deleteDocument';
import tenderDocumentsHandlers from './tenders/documents';
import tenderQualificationHandlers from './tenders/qualification';
import timesheetsExportHandlers from './timesheets/export';
import timesheetMonthHandlers from './timesheets/month';
import timesheetsSaveDayHandlers from './timesheets/saveDay';
import usersHandlers from './users';

/* Enregistre tous les traitements métier dans `api`, dans le même ordre qu'auparavant. Chaque
   fabrique reçoit l'état (deps) et `api` elle-même, lu au moment de l'appel : un domaine peut
   appeler les traitements d'un autre sans dépendre de l'ordre de création. */
export function registerHandlers(api, deps) {
  Object.assign(api, tenderQualificationHandlers(deps, api));
  Object.assign(api, tenderAnalysisHandlers(deps, api));
  Object.assign(api, tenderDocumentsHandlers(deps, api));
  Object.assign(api, tenderDeleteDocumentHandlers(deps, api));
  Object.assign(api, dealPipelineHandlers(deps, api));
  Object.assign(api, phaseClosureHandlers(deps, api));
  Object.assign(api, projectArchiveHandlers(deps, api));
  Object.assign(api, dealsLoadingHandlers(deps, api));
  Object.assign(api, dealNamesHandlers(deps, api));
  Object.assign(api, dealViewsHandlers(deps, api));
  Object.assign(api, dealFormHandlers(deps, api));
  Object.assign(api, dealOpenHandlers(deps, api));
  Object.assign(api, dealActivitiesHandlers(deps, api));
  Object.assign(api, dealConversionHandlers(deps, api));
  Object.assign(api, tenderToDealHandlers(deps, api));
  Object.assign(api, clientsHandlers(deps, api));
  Object.assign(api, timesheetMonthHandlers(deps, api));
  Object.assign(api, timesheetsSaveDayHandlers(deps, api));
  Object.assign(api, timesheetsExportHandlers(deps, api));
  Object.assign(api, jiraEpicsHandlers(deps, api));
  Object.assign(api, jiraEpicMonthsHandlers(deps, api));
  Object.assign(api, jiraSyncHandlers(deps, api));
  Object.assign(api, jiraAuthorsHandlers(deps, api));
  Object.assign(api, jiraUnmatchedHandlers(deps, api));
  Object.assign(api, jiraLogsHandlers(deps, api));
  Object.assign(api, jiraConsumptionHandlers(deps, api));
  Object.assign(api, jiraLabelHoursHandlers(deps, api));
  Object.assign(api, jiraIssueKeyMapHandlers(deps, api));
  Object.assign(api, phaseInfoHandlers(deps, api));
  Object.assign(api, absencesLoadingHandlers(deps, api));
  Object.assign(api, absencesBalancesHandlers(deps, api));
  Object.assign(api, absencesRequestsHandlers(deps, api));
  Object.assign(api, absencesEditHandlers(deps, api));
  Object.assign(api, absencesTimesheetsHandlers(deps, api));
  Object.assign(api, absencesNotificationsHandlers(deps, api));
  Object.assign(api, usersHandlers(deps, api));
  Object.assign(api, planningAssignmentsHandlers(deps, api));
  Object.assign(api, planningDeleteDayHandlers(deps, api));
  Object.assign(api, planningValidationHandlers(deps, api));
  Object.assign(api, phaseSaveHandlers(deps, api));
  Object.assign(api, phaseEndAlertsHandlers(deps, api));
  Object.assign(api, maintenanceCarryOverHandlers(deps, api));
  Object.assign(api, seenAlertsHandlers(deps, api));
  return api;
}
